import React from "react";
import {
  ActivityIndicator,
  Platform,
  RefreshControl,
  ScrollView,
  View
} from "react-native";
import { Observer, observer } from "mobx-react";
import { theme } from "../../../../config/style-configs/theme";
import { UIText } from "../../../../config/lang-config";
import { Text } from "react-native-elements";
import { ListRefreshButtonWeb } from "../../../../components/ListRefreshButtonWeb";
import { TopicCard } from "../../../../components/TopicCard";
import { ThemedButton } from "../../../../components/ThemedButton";

@observer
class MCBProactiveChatListView extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  componentWillUnmount() {
    return this.controller.componentWillUnmount();
  }

  renderSortButtons = () => (
    <>
      <ThemedButton
        icon={
          this.controller.sortBy === "dateAscend"
            ? "expand-less"
            : this.controller.sortBy === "dateDescend"
            ? "expand-more"
            : undefined
        }
        title={UIText.adminCentreSortByDate}
        onPress={this.controller.sortByDate}
      />
      <ThemedButton
        icon={
          this.controller.sortBy === "alphaAscend"
            ? "expand-less"
            : this.controller.sortBy === "alphaDescend"
            ? "expand-more"
            : undefined
        }
        title={UIText.adminCentreSortByName}
        onPress={this.controller.sortByAlpha}
      />
    </>
  );

  renderTopics = topics => {
    if (!Array.isArray(topics) || topics.length === 0)
      return (
        <Text style={this.props.styles.errorMessage}>
          {UIText.inboxNoLastActivity}
        </Text>
      );

    return (
      <View style={this.props.styles.scrollViewCard}>
        {topics.map(this.renderTopic)}
      </View>
    );
  };

  renderTopic = topic => {
    // const group = topic.group;
    // const profile = topic.gProfile;

    const children = (
      <View style={this.props.styles.cardContent}>
        {topic["createTime"] && (
          <Text
            numberOfLines={2}
            ellipsizeMode="tail"
            style={{
              ...this.props.styles.cardContentMedium,
              fontWeight: "normal"
            }}
          >
            {UIText.createdAt}: {new Date(topic["createTime"]).toLocaleString()}
          </Text>
        )}
        <Text
          numberOfLines={2}
          ellipsizeMode="tail"
          style={{
            ...this.props.styles.cardContentMedium,
            fontWeight: "normal"
          }}
        >
          {topic["lastPublicMessageTime"]
            ? UIText.inboxLastMessageAt(
                `\n${new Date(topic["lastPublicMessageTime"]).toLocaleString()}`
              )
            : UIText.inboxNoLastActivity}
        </Text>
      </View>
    );

    return (
      <Observer key={topic.id}>
        {() => (
          <View style={this.props.styles.card}>
            <TopicCard
              compact={true}
              title={topic.description}
              avatarTitle={topic.description
                .replace(/website\svisitor/gi, "")
                .trim()
                .toUpperCase()}
              titleId={topic.id}
              pending={topic.loading}
              onPress={() => this.controller.openChat(topic.id)}
            >
              {children}
            </TopicCard>
          </View>
        )}
      </Observer>
    );
  };

  render() {
    return (
      <View style={this.props.styles.style}>
        {(this.controller.loading || this.controller.refreshing) &&
        Platform.OS === "web" ? (
          <View style={this.props.styles.loading}>
            <ActivityIndicator size="large" color={theme.color} />
          </View>
        ) : (
          <ScrollView
            contentContainerStyle={this.props.styles.scrollView}
            refreshControl={
              <RefreshControl
                refreshing={
                  this.controller.refreshing || this.controller.loading
                }
                onRefresh={this.controller.onRefresh}
              />
            }
          >
            <View style={this.props.styles.scrollViewContent}>
              <View style={this.props.styles.buttonContainer}>
                {this.controller.isMCBGroup && this.renderSortButtons()}
                {!this.controller.loading && (
                  <ListRefreshButtonWeb onRefresh={this.controller.onRefresh} />
                )}
              </View>
              {this.renderTopics(this.controller.filteredTopics)}
            </View>
          </ScrollView>
        )}
      </View>
    );
  }
}

export { MCBProactiveChatListView };
